import {createQueryKeys} from "@lukemorales/query-key-factory";

export const Auth = createQueryKeys('auth', {
    user: ['user']
})